import React from 'react'
import { array } from 'prop-types'
import { branch } from 'baobab-react/higher-order'

import BaseTemplate from 'components/templates/BaseTemplate'
import { Container } from 'components/qstrap'
import Star from 'components/atoms/SVGIcons/Star'
import Typography from 'components/atoms/Typography'
import Thumbnails from 'components/organisms/Thumbnails'
import AptitudeEmptyPlaceholder from 'components/organisms/AptitudeEmptyPlaceholder'

const Interest = ({ schoolInterest }) => {
  const schoolInterestsList = schoolInterest.map(school => ({
    ...school,
    interested: true,
    enabled: false,
  }))

  return (
    <BaseTemplate useNewHeader>
      <div className="interest">
        <div className="interest__page-title">
          <Container>
            <div className="interest__page-title-container">
              <Star size={24} fill="#8FB0D4" className="interest__icon" />
              <h1 className="interest__page-heading">
                Kampus Rekomendasi
              </h1>
            </div>
          </Container>
        </div>
        <div className="interest__disclaimer">
          <Container>
            <Typography component="p" variant="note" className="aptitude-recommendation__note">
              * Pihak kampus yang kamu minati bisa menghubungi untuk memberikan info lebih lengkap mulai dari pendaftaran, biaya kuliah hingga beasiswa.
            </Typography>
          </Container>
        </div>
        {
          schoolInterestsList.length > 0 &&
          <Thumbnails
            kind="schools"
            data={schoolInterestsList}
            isLikeable={false}
          />
        }
        {
          schoolInterestsList.length === 0 &&
          <AptitudeEmptyPlaceholder />
        }
      </div>
      <style jsx>
        {`
          .interest {
            &__page-title {
              background: #e3ecf5;
              padding: 30px 0;
            }
            &__page-title-container {
              display: flex;
              align-items: center;
            }
            :global(&__icon) {
              margin-right: 16px;
            }
            &__page-heading {
              font-size: 24px;
              margin: 0;
              color: #1e3f6b;
              font-weight: bold;
            }
            &__disclaimer {
              background: ${schoolInterestsList.length === 0 ? 'inherit' : '#fff'};
              padding: 8px 0;
            }
          }
        `}
      </style>
    </BaseTemplate>
  )
}

Interest.propTypes = {
  schoolInterest: array,
}

export { Interest }
export default branch({
  schoolInterest: ['serverProps', 'school_interest'],
}, Interest)
